export interface IGPSCounts {
    pendShip: number,
    shippedToMC: number,
    pendingGPS: number,
    needsActivation: number,
    inProcess: number,
    returnToNKR: number,
    pendNkrReceipt: number
}